import { useParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../hooks'
import { getFolderList, sortFolderList } from '../store/actions/folder'
import { useEffect, useState } from 'react'
import { getCategory } from '../store/actions/category'
import FolderList from '../components/FolderList/FolderList'
import { getFileList } from '../store/actions/file'
import { useAuth } from '../hooks/useAuth'
import { setFolderList } from '../store/reducers/folder'
import { setFileList } from '../store/reducers/file'

const Category = () => {
  const dispatch = useAppDispatch()
  const { category_id = '', folder_id = '' } = useParams()
  const [loading, setLoading] = useState<boolean>(true)
  const { sort, id, view } = useAppSelector((state) => state.page)
  const { fileList } = useAppSelector((state) => state.file)
  const { folderList } = useAppSelector((state) => state.folder)

  const fetch = async () => {
    if (id !== category_id) {
      await dispatch(getCategory(category_id))
    }

    await Promise.all([
      dispatch(getFolderList(folder_id)),
      dispatch(getFileList(folder_id)),
    ])

    setLoading(false)
  }

  useEffect(() => {
    fetch()

    return () => {
      dispatch(setFolderList([]))
      dispatch(setFileList([]))
    }
  }, [folder_id])

  useEffect(() => {
    if (sort) {
      dispatch(sortFolderList(sort))
    }
  }, [sort])

  return (
    <FolderList
      list={folderList}
      files={fileList}
      isGrid={view === 'grid'}
      loading={loading}
    />
  )
}

export default Category
